<template>
    <div>
        <span class="link" @click="showModal();">In English</span>

        <modal name="inEnglishModal" height="auto">
            <div class="modal-header">
                <h5 class="mb-0">Multilingual Support</h5>
            </div>
            <div class="modal-body">
                <p>Coming soon!</p>

                <p>
                    We're still working on supporting English natively on our platform.<br>
                    While we get ready, we recommend using a browser that supports translations natively - e.g. Google Chrome.
                </p>

                <p>We thank you for patience and understanding.</p>
            </div>
        </modal>
    </div>
</template>

<script>
export default {
    methods: {
        showModal() {
            this.$modal.show('inEnglishModal');
        },
        hideModal() {
            this.$modal.hide('inEnglishModal');
        }
    },
}
</script>
